import { Component, NgModule, OnInit } from '@angular/core';

@Component({
  selector: 'ben-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  footerText: string = "";

  ngOnInit(): void {
    this.footerText = `© ${(new Date()).getFullYear()} www.benenden.co.uk`;
  }
}
